"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkContext = checkContext;
const display_1 = require("../../tools/display");
const typeUtils_1 = require("../../tools/utils/typeUtils");
/**
 * Simple check to ensure an object is a valid context
 */
function checkContext(maybeContext) {
    const isValid = (0, typeUtils_1.getType)(maybeContext) === 'object';
    if (!isValid) {
        display_1.display.error('Unsupported context:', maybeContext);
    }
    return isValid;
}
//# sourceMappingURL=contextUtils.js.map